import actions from 'redux/actions'
import constants from 'common/helpers/constants'
import mixpanel from 'common/helpers/analytics/mixpanel'
import getCookieValue from 'helpers/getCookieValue'
import formatPrice from 'common/helpers/modifiers/formatPrice'

import messages from './messages'


const getBillData = (values = {}) => {
  const {
    gender, selectedPlan, subscriptionCasePrice,
    bill: { price = 0, tax = 0, discount: billDiscount = 0, offer: billOffer, upchargePrice } = {},
    subscription: { price: subscriptionPrice = 1495, shipping: subscriptionShippingPrice, discount: subscriptionDiscount } = {},
    coupon: { code } = {},
  } = values

  const items         = []
  const offerCookie   = getCookieValue(constants.cookieNames.offer, true)
  const couponCookie  = getCookieValue(constants.cookieNames.discountCoupon, true)
  const offer         = billOffer || offerCookie // TODO mbe we should always take offer from inquire response?

  // Product ------------------------------------------------------------ /

  let productLabel
  let productValue = formatPrice(subscriptionPrice, true)

  if (offer === constants.offerNames.secondMonthFree) {
    productLabel = messages.product.monthlySubscription
  }
  else if (offer === constants.offerNames.thirdMonthFree) {
    productLabel = messages.product.thirdMonthFree // TODO weird text for such offer - "3 month of fragrance"
  }
  else if (couponCookie === constants.discountCoupons.fivemonthdiscount) {
    productLabel = messages.product.monthlySubscription
  }
  // else if (
  //  couponCookie === constants.discountCoupons.freeTrial
  //  || couponCookie === constants.discountCoupons.freeTrial7
  // ) { // TODO it shouldn't be in new users subscribe flow
  //   productLabel = messages.product.freeTrial
  //   productValue = messages.product.free
  // }
  else {
    productLabel = messages.product.monthlySubscription
  }

  let productCountPerMonth = 1

  if (/_2PCS/.test(selectedPlan)) {
    productCountPerMonth = 2
  }
  else if (/_3PCS/.test(selectedPlan)) {
    productCountPerMonth = 3
  }

  items.push({
    id: 'billSubscriptionProductRow',
    label: productLabel,
    note: { ...messages.productsPerMonth, values: { count: productCountPerMonth } },
    value: productValue,
    amount: formatPrice(subscriptionPrice, true, false),
  })

  // Case subscription  ------------------------------------------------ /

  if (subscriptionCasePrice) {
    items.push({
      id: 'billSubscriptionCasePriceRow',
      label: messages.caseSubscription,
      value: formatPrice(subscriptionCasePrice, true),
      amount: formatPrice(subscriptionCasePrice, true, false),
      onRemove: () => {
        mixpanel.track(constants.analyticsEvents.casesSubscription.remove)
        actions.models.payment.setSubscriptionCaseStatus(false)
      },
    })
  }

  // Upcharge ---------------------------------------------------------- /

  if (upchargePrice) {
    items.push({
      id: 'billSubscriptionUpchargeRow',
      label: messages.upcharge.label,
      note: messages.upcharge.note,
      value: formatPrice(upchargePrice, true),
      amount: formatPrice(upchargePrice, true, false),
    })
  }

  // Shipping ----------------------------------------------------------- /

  items.push({
    id: 'billSubscriptionShippingRow',
    label: messages.shipping,
    value: subscriptionShippingPrice ? formatPrice(subscriptionShippingPrice, true) : messages.free,
    amount: formatPrice(0, true, false),
    brand: true,
  })

  // Tax ---------------------------------------------------------------- /

  items.push({
    id: 'billTaxRow',
    label: messages.tax,
    value: formatPrice(tax, true),
    amount: formatPrice(tax, true, false),
  })

  // Discount ----------------------------------------------------------- /

  let discountLabel
  let discountValue
  let discountApplePayValue = formatPrice(billDiscount, true, false)

  const isFreeTrial          = false // couponCookie === constants.discountCoupons.freeTrial // TODO it shouldn't be in new users subscribe flow
  const isOfferForFirstMonth = Object.values(constants.discountCoupons).slice(0, -2).includes(code)

  if (subscriptionDiscount) {
    discountLabel = messages.discount.subscription
    discountValue = typeof subscriptionDiscount === 'string'
      ? subscriptionDiscount
      : formatPrice(subscriptionDiscount, true)
  }

  if (offer === constants.offerNames.secondMonthFree) {
    discountLabel = { ...messages.discount.secondMonthFree, values: { gender } }
    discountValue = messages.free
    discountApplePayValue = formatPrice(0, true, false)
  }
  else if (offer === constants.offerNames.thirdMonthFree) {
    discountLabel = messages.discount.thirdMonthFree
  }
  else if (couponCookie === constants.discountCoupons.fivemonthdiscount) {
    discountLabel = messages.discount.common
  }

  if (!isFreeTrial && discountLabel && discountValue) {
    items.push({
      id: 'billSubscriptionDiscountRow',
      label: discountLabel,
      value: discountValue,
      amount: discountApplePayValue,
      brand: true,
      note: isOfferForFirstMonth ? messages.offerNote : null,
    })
  }

  // Total ---------------------------------------------------------------- /

  return {
    items,
    total: price || 0,
  }
}


export {
  getBillData,
}
